export default "__VITE_PUBLIC_ASSET__9c0f8e32__"